import apiService from '@/core/common/services/api.service';

export function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' Byte';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

export function getFileIcon(dateiname) {
  if (!dateiname) return 'File';
  const ext = dateiname.split('.').pop().toLowerCase();
  if (['jpeg', 'jpg', 'png'].includes(ext)) return 'ImageIcon';
  if (['xlsx', 'xls', 'csv'].includes(ext)) return 'FileSpreadsheet';
  if (['pdf', 'txt', 'docx'].includes(ext)) return 'FileText';
  return 'File';
}

export async function uploadDatei(aufgabeId, file) {
  const formData = new FormData();
  formData.append('aufgabeId', aufgabeId.toString());
  formData.append('datei', file);
  return apiService.post('/aufgaben/dateien', formData);
}

export async function deleteDatei(dateiId) {
  return apiService.delete('/aufgaben/dateien/' + dateiId);
}

// Löst den Browser-Download für ein Blob aus, indem ein temporärer Link erzeugt,
// programmatisch geklickt und anschließend samt Objekt-URL wieder aufgeräumt wird
export function triggerBrowserDownload(blob, dateiname) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', dateiname);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Liest aus dem Beschreibungs-HTML die Dateinamen aller eingefügten Bilder aus
// Der Dateiname steht im alt-Attribut der img-Tags und dient zum Abgleich mit den Datei-Anhängen
export function getReferenzierteBildDateinamen(html) {
  const dateinamen = new Set();
  if (!html) return dateinamen;
  const temp = document.createElement('div');
  temp.innerHTML = html;
  temp.querySelectorAll('img[alt]').forEach(img => {
    const alt = img.getAttribute('alt');
    if (alt) dateinamen.add(alt);
  });
  return dateinamen;
}
